var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarFemale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m500,250.0001c0,56.0702-18.46,107.7981-49.5903,149.5055-45.6043,60.9914-118.3976,100.4943-200.4097,100.4943s-154.8276-39.503-200.432-100.5166C18.4378,357.7759,0,306.0479,0,250.0001,0,111.9401,111.9177,0,250,0s250,111.94,250,250Z",
    fill: "none",
    strokeWidth: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m500.5347,250.0001c0,56.0702-18.46,107.7981-49.5903,149.5055-45.6043,60.9914-118.3976,100.4943-200.4097,100.4943s-154.8276-39.503-200.432-100.5166C18.9724,357.7759.5347,306.0479.5347,250.0001.5347,111.9401,112.4524,0,250.5347,0s250,111.94,250,250Z",
    fill: "#d8d7ea",
    strokeWidth: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m233.3058,49.2822s51.4988-17.0244,81.2915,21.7061c29.7927,38.7305,46.6043,96.4007,46.6043,133.216s10.8531,99.5928,3.6177,146.4099h-229.8295s-6.3842-58.7342,2.1281-154.9221c8.5122-96.1879,60.8622-159.6038,96.1879-146.4099Z",
    fill: "#212121",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.1258,317.4962c-86.9582,21.368-99.0395-62.2321-99.0395-62.2321v-8.069h93.6482v51.3601c0,6.8241,1.9256,13.3527,5.3913,18.9409Z",
    fill: "#efb181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.2399,92.6944s-11.4915,8.0866-24.6854,24.2598c-13.1939,16.1732-18.7268,54.0525-18.7268,54.0525,0,0-1.4896-7.661-5.9585-8.2994-4.4689-.6384-15.9604,10.8531-3.1921,45.3275,0,0,6.597,21.2805,13.1939,10.0018,0,0,23.8342,66.8208,68.3104,66.8208s65.3312-70.2257,65.3312-70.2257c0,0-.2128,6.597,5.9585,6.597s22.7701-47.0299,6.1713-59.5854c0,0-1.064,16.386-7.8738,15.7476,0,0,2.7665-33.1976-43.1994-48.9452-45.9659-15.7476-55.3293-35.7513-55.3293-35.7513Z",
    fill: "#f4c89e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.9743,215.2827s-15.475-37.1795-6.4481-44.0566c9.027-6.8771,10.9612,12.2499,10.9612,12.2499,0,0-1.0746,5.8026-5.5877,5.3728s1.0746,26.4339,1.0746,26.4339Z",
    fill: "#efb181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.6307,171.2261c-.8721-.6644-1.6763-1.0809-2.4207-1.3005-1.4327,8.2772-7.4976,8.0349-7.4976,8.0349h0c-.7794,2.9283-1.0429,5.5156-1.0429,5.5156,0,0,1.0745,5.8026,5.5876,5.3727s-1.0745,26.434-1.0745,26.434c0,0,15.475-37.1794,6.4481-44.0566Z",
    fill: "#efb181",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.9505,336.1416s-.009.0537-.0268.1612c-.2776,1.827-3.1703,18.9947-13.487,36.1804-10.9169,18.1797-30.1623,36.3774-63.4412,36.4401h-.1701c-66.5666-.1344-76.955-72.7817-76.955-72.7817l10.854-5.6509c11.902-6.2062,19.3618-18.5111,19.3618-31.9355v-43.2911s12.0812,83.6001,99.0395,62.2321c3.3404,5.4181,8.1227,9.9407,13.9707,12.9945l10.854,5.6509Z",
    fill: "#f4c89e",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m468.4303,479.3587s-39.4492,50.7601-218.4348,50.7601-218.4259-50.7601-218.4259-50.7601l17.4277-55.5244c8.6331-27.4845,29.1412-49.6495,55.8736-60.3872l67.9996-27.3055s10.3883,72.6474,76.955,72.7817h.1701c33.2788-.0627,52.5243-18.2604,63.4412-36.4401,10.3167-17.1857,13.2094-34.3535,13.487-36.1804l.206-.1612,67.9905,27.3055c26.7412,10.7377,47.2495,32.9027,55.8736,60.3872l17.4365,55.5244Z",
    fill: "#946caa",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFemale);
export default __webpack_public_path__ + "static/media/avatar-female.91b08b1c14cbc9a287c14e5e8a4188e9.svg";
export { ForwardRef as ReactComponent };